import { render, staticRenderFns } from "./Trainingsplan.vue?vue&type=template&id=a1b22abc&scoped=true&"
import script from "./Trainingsplan.vue?vue&type=script&lang=js&"
export * from "./Trainingsplan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b22abc",
  null
  
)

export default component.exports